import React from 'react';
import OrgTag from '../../components/OrgTag';
import { fmtNumber } from '../../hooks';
import DirectoryList from './DirectoryList';

const SECTIONS = [
  { title: 'Basics', fields: [
    { key: 'first_name', label: 'First name', required: true },
    { key: 'last_name', label: 'Last name' },
    { key: 'middle_name', label: 'Middle name' },
    { key: 'nick_name', label: 'Nick name' },
    { key: 'display_name', label: 'Display name', full: true, hint: 'Shown in placements and reports. Leave empty to use first and last name.' },
    { key: 'email_id', label: 'Email', type: 'email', required: true, full: true, hint: 'Also used to send onboarding reminders.' },
  ] },
  { title: 'Work', fields: [
    { key: 'role', label: 'Role', suggest: 'role' },
    { key: 'team_name', label: 'Team', suggest: 'team_name' },
    { key: 'reporting_to', label: 'Reports to', type: 'person' },
    { key: 'date_of_joining', label: 'Date of joining', type: 'date' },
    { key: 'location', label: 'Location', suggest: 'location' },
  ] },
  { title: 'Phone', fields: [
    { key: 'contact_number', label: 'Mobile', type: 'phone' },
    { key: 'direct_number', label: 'Direct', type: 'phone' },
    { key: 'office_number', label: 'Office', type: 'phone' },
  ] },
];

const FILTERS = [
  { key: 'role', placeholder: 'All roles' },
  { key: 'team_name', placeholder: 'All teams' },
  { key: 'location', placeholder: 'All locations' },
];

const columns = (combined) => [
  { key: 'display_name', label: 'Recruiter', sortable: true, render: (r) => <div><b>{r.display_name}</b><div className="muted">{r.email_id}</div></div> },
  ...(combined ? [{ key: 'organization', label: 'Organization', render: (r) => <OrgTag orgKey={r.organization} /> }] : []),
  { key: 'role', label: 'Role', sortable: true },
  { key: 'team_name', label: 'Team', sortable: true },
  { key: 'location', label: 'Location', sortable: true },
  { key: 'reporting_to', label: 'Reports to' },
  { key: 'date_of_joining', label: 'Joined', sortable: true, render: (r) => String(r.date_of_joining || '').slice(0, 10) || '—' },
  { key: 'placements', label: 'Placements', align: 'right', render: (r) => fmtNumber(r.placements) },
];

export default function Recruiters({ org }) {
  return (
    <DirectoryList org={org} kind="recruiters" noun="Recruiter" plural="recruiters" idKey="employee_id" nameKey="display_name" sections={SECTIONS}
      filters={FILTERS} columns={columns} initialOrdering="display_name" />
  );
}
